import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { AdminPanel } from './LearnerAndAdmin';
import { apiService } from '../services/apiService';

export default function AdminLogin() {
  const { user, login, toast } = useApp();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  if (user?.role === 'admin') return <AdminPanel />;

  const handleSubmit = async () => {
    const errs = {};
    if (!form.email) errs.email = 'Email required';
    if (!form.password) errs.password = 'Password required';
    if (Object.keys(errs).length) { setErrors(errs); return; }

    setLoading(true);
    setErrors({});

    try {
      const response = await apiService.adminLogin(form.email, form.password);

      const adminUser = {
        id: response.data.userId,
        name: `${response.data.firstName} ${response.data.lastName}`,
        role: response.data.role,
        email: response.data.email,
        token: response.data.token,
        bg: '#C13030',
      };

      login(adminUser);
      toast('Welcome, Admin! 👋', 'success');
      navigate('/admin');
    } catch (error) {
      setErrors({ submit: error.message || 'Login failed' });
      toast(error.message || 'Login failed', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: 'calc(100vh - 60px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, background: 'var(--bg)' }}>
      <div className="card" style={{ maxWidth: 400, width: '100%', padding: 36, animation: 'fadeUp 0.3s ease' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 28 }}>
          <div style={{ width: 36, height: 36, borderRadius: 8, background: 'linear-gradient(135deg, #C13030, #8B1A1A)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16 }}>👑</div>
          <div>
            <div style={{ fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 700, color: 'var(--ink)' }}>Admin Access</div>
            <div style={{ fontSize: 12, color: 'var(--ink4)' }}>MakeMyExpert Control Panel</div>
          </div>
        </div>

        <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 4 }}>Sign in</h2>
        <p className="text-sm text-ink3 mb-24">Enter your admin credentials to continue.</p>

        <div className="form-group">
          <label className="form-label">Email</label>
          <input
            className="form-input"
            type="email"
            placeholder="admin@example.com"
            value={form.email}
            onChange={e => { setForm(f => ({ ...f, email: e.target.value })); setErrors({}); }}
            onKeyDown={e => e.key === 'Enter' && handleSubmit()}
          />
          {errors.email && <div className="form-error">{errors.email}</div>}
        </div>

        <div className="form-group">
          <label className="form-label">Password</label>
          <input
            className="form-input"
            type="password"
            placeholder="••••••••"
            value={form.password}
            onChange={e => { setForm(f => ({ ...f, password: e.target.value })); setErrors({}); }}
            onKeyDown={e => e.key === 'Enter' && handleSubmit()}
          />
          {errors.password && <div className="form-error">{errors.password}</div>}
        </div>

        {errors.submit && <div className="form-error" style={{ marginBottom: 16 }}>{errors.submit}</div>}

        <button
          onClick={handleSubmit}
          disabled={loading}
          className="btn btn-primary w-full"
          style={{ justifyContent: 'center', background: '#C13030', borderColor: '#C13030' }}
        >
          {loading ? 'Signing in…' : 'Sign In'}
        </button>
      </div>
    </div>
  );
}
